module.exports = __webpack_public_path__ + "img/720.ff9a68a1.svg";